import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_INPUT_GENERICO, ESTILO_BOTON_GENERAL_CANCELAR } from "../../utils/const/estilos-const";
import "../../style/style-cargando.css";
import Spinner from "../../components/spinner";
import ArrowBack from "../../components/arrow-back";
import { useTranslation } from "react-i18next";
import ProcessingDialog from "../../components/processing-dialog";
import ToastComponent from "../../components/toast-component";
import { obtenerListaPersona } from "../../api/api-persona";
import Select from "react-select";
import TimeComponent from "../../components/time-component";
import Calendar from "../../components/calendar";
import { actualizarViaje, crearViaje, obtenerGeocercasViaje, obtenerGeoruta } from "../../api/api-viaje";
import moment from "moment";
import { obtenerListaEstadoSolicitud } from "../../api/api-estado-solicitud";
import GraficoViajeComponent from "../../components/grafico_viaje_component";

export default function ViajePage() {
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");

  const [processingVisible, setProcessingVisible] = useState(false);
  const [toastVisible, setToastVisible] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("warning");

  const [requestSend, setRequestSend] = useState(false);

  const [listaPersonas, setListaPersonas] = useState([]);

  const [listaGeocercas, setListaGeocercas] = useState([]);
  const [geocercaInicioSelected, setGeocercaInicioSelected] = useState(null);
  const [geocercaFinSelected, setGeocercaFinSelected] = useState(null);
  const [georutaSelected, setGeorutaSelected] = useState(null);
  const [listaGeoruta, setListaGeoruta] = useState([]);

  const [listaEstadosSolicitud, setListaEstadosSolicitud] = useState([]);
  const [estadoSolicitudSelected, setEstadoSolicitudSelected] = useState(null);

  const [personaNotificarInicioViaje, setPersonaNotificarInicioViaje] = useState(null);
  const [personaNotificarFinViaje, setPersonaNotificarFinViaje] = useState(null);
  const [personaNotificarAlerta, setPersonaNotificarAlerta] = useState(null);

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      console.log("data");
      console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
        // Initialize dynamic fields if they exist
      }
      const personas = await obtenerListaPersona({ habilitado: 1 }, true);
      setListaPersonas(personas);
      if (data.params.notificarInicioViaje !== undefined && data.params.notificarInicioViaje !== null) {
        setPersonaNotificarInicioViaje(JSON.parse(data.params.notificarInicioViaje));
      }
      if (data.params.notificarFinViaje !== undefined && data.params.notificarFinViaje !== null) {
        setPersonaNotificarFinViaje(JSON.parse(data.params.notificarFinViaje));
      }
      const responseGeocerca = await obtenerGeocercasViaje();
      if (responseGeocerca.error === false) {
        setListaGeocercas(responseGeocerca.body);
      }
      if (data.params.geocercaInicio !== undefined && data.params.geocercaInicio !== null) {
        setGeocercaInicioSelected(JSON.parse(data.params.geocercaInicio));
      }
      if (data.params.geocercaFin !== undefined && data.params.geocercaFin !== null) {
        setGeocercaFinSelected(JSON.parse(data.params.geocercaFin));
      }
      if (data.params.geoRuta !== undefined && data.params.geoRuta !== null) {
        setGeorutaSelected(JSON.parse(data.params.geoRuta));
      }
      const responseGeoruta = await obtenerGeoruta();
      if (responseGeoruta.error === false) {
        setListaGeoruta(responseGeoruta.body);
      }
      const responseEstadosSolicitud = await obtenerListaEstadoSolicitud({ habilitado: 1 }, true, t);
      // console.log('responseEstadosViaje');
      // console.log(responseEstadosViaje);
      if (Array.isArray(responseEstadosSolicitud)) {
        setListaEstadosSolicitud(responseEstadosSolicitud);
      }
      if (data.params.idEstadoSolicitud !== undefined && data.params.idEstadoSolicitud !== null && Array.isArray(responseEstadosSolicitud)) {
        const estado = responseEstadosSolicitud.find((item) => item.value === data.params.idEstadoSolicitud);
        setEstadoSolicitudSelected(estado);
      }
      if (data.params.notificarAlerta !== undefined && data.params.notificarAlerta !== null) {
        setPersonaNotificarAlerta(JSON.parse(data.params.notificarAlerta));
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }
  }

  const charLimits = {
    codigo: 64,
    descripcion: 128,
    nota: 512,
    cantidadVehiculosRequeridos: 7,
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let next = value;
    if (name === "cantidad_vehiculos_requeridos") {
      next = value.replace(/\D/g, "");
    }
    if (next.length <= charLimits[name]) {
      setFormData({
        ...formData,
        [name]: next,
      });
    }
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const validarFormulario = () => {
    try {
      let message = "";
      if (estadoSolicitudSelected === null) {
        message = message + t("alert_debe_seleccionar_estado_solicitud") + '\n';
      }
      if (String(formData.descripcion).trim().length === 0) {
        message = message + t("alert_debe_ingresar_descripcion") + '\n';
      }
      if (geocercaInicioSelected === null) {
        message = message + t("alert_debe_seleccionar_geocerca_inicio") + '\n';
      }
      if (geocercaFinSelected === null) {
        message = message + t("alert_debe_seleccionar_geocerca_fin") + '\n';
      }
      if (georutaSelected === null) {
        message = message + t("alert_debe_seleccionar_georuta") + '\n';
      }

      if (String(formData.cantidadVehiculosRequeridos).trim().length === 0) {
        message = message + t("alert_debe_ingresar_cantidad_vehiculos_requeridos") + '\n';
      }
      if (moment(formData.fechaInicio).isValid() === false) {
        message = message + t("alert_fecha_inicio_no_valido") + '\n';
      }

      if (moment(formData.fechaFin).isValid() === false) {
        message = message + t("alert_fecha_fin_no_valido") + '\n';
      }

      if (moment(formData.horaInicio, "HH:mm", true).isValid() === false) {
        message = message + t("alert_hora_inicio_no_valido") + '\n';
      }

      if (moment(formData.horaFin, "HH:mm", true).isValid() === false) {
        message = message + t("alert_hora_fin_no_valido") + '\n';
      }


      if (message.length > 0) {
        showToast(message.trim(), "warning", 4000);
        return false;
      }
      return true;
    } catch (err) {
      console.log('validarFormulario err');
      console.log(err);
      return false;
    }
  };

  const showToast = (message, type = "warning", durationMs = 3000) => {
    setToastMessage(message);
    setToastType(type);
    setToastVisible(true);
    // Auto-hide
    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      setToastVisible(false);
    }, durationMs);
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('formData');
    // console.log(formData);
    const valido = validarFormulario();
    if (valido === false) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.idEstadoSolicitud = estadoSolicitudSelected?.value;
    objEnviar.codigo = formData.codigo;
    objEnviar.descripcion = formData.descripcion;
    objEnviar.nota = formData.nota;
    objEnviar.geocercaInicio = geocercaInicioSelected;
    objEnviar.geocercaFin = geocercaFinSelected;
    objEnviar.fechaInicio = formData.fechaInicio;
    objEnviar.horaInicio = formData.horaInicio;
    objEnviar.fechaFin = formData.fechaFin;
    objEnviar.horaFin = formData.horaFin;
    objEnviar.notificarInicioViaje = personaNotificarInicioViaje;
    objEnviar.notificarFinViaje = personaNotificarFinViaje;
    objEnviar.geoRuta = georutaSelected;
    objEnviar.cantidadVehiculosRequeridos = formData.cantidadVehiculosRequeridos;
    objEnviar.notificarAlerta = personaNotificarAlerta;
    // console.log('objEnviar');
    // console.log(objEnviar);
    // return;
    setRequestSend(true);
    setProcessingVisible(true);
    try {
      if (formData.id === 0) {
        // console.log('crear correo');
        const response = await crearViaje(objEnviar);
        setProcessingVisible(false);
        // console.log('creado');
        // console.log(creado);
        if (response.error === false) {
          showToast(t("alert_se_creo_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_crear"));
        }
      }
      if (formData.id !== 0) {
        // console.log('actualizar correo');
        const response = await actualizarViaje(objEnviar);
        setProcessingVisible(false);
        // console.log('modificado');
        // console.log(modificado);
        if (response.error === false) {
          showToast(t("alert_se_modifico_correctamente"));
          handleCancelClick();
        }
        if (response.error === true) {
          showToast(t("alert_no_se_pudo_modificar"));
        }
      }
    } catch (err) {
      console.log('handleSaveClick err');
      console.log(err);
      setProcessingVisible(false);
    } finally {
      setRequestSend(false);
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      // if (cargandoPage === true) {
      //   return cargandoCard();
      // }
      // if (cargandoPage === false && formData === null) {
      //   return (
      //     <div>
      //       <label> Sin data</label>
      //     </div>
      //   );
      // }
      const selectMenuStyles = {
        container: (base) => ({ ...base, width: "100%", minWidth: 0 }),
        control: (base) => ({ ...base, minHeight: 38, minWidth: 0 }),
        valueContainer: (base) => ({
          ...base,
          minWidth: 0,
          flexWrap: "nowrap",
        }),
        singleValue: (base) => ({
          ...base,
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }),
        placeholder: (base) => ({
          ...base,
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }),
        input: (base) => ({ ...base, margin: 0, padding: 0 }),
        indicatorsContainer: (base) => ({ ...base, flexShrink: 0 }),
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (base) => ({
          ...base,
          zIndex: 9999,
          width: "auto",
          minWidth: "100%",
          maxWidth: "min(92vw, 28rem)",
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: "min(280px, 40vh)",
        }),
        option: (base) => ({
          ...base,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }),
        multiValue: (base) => ({ ...base, maxWidth: "100%" }),
        multiValueLabel: (base) => ({
          ...base,
          maxWidth: 140,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }),
      };

      const reactSelectLayoutProps = {
        className: "w-full min-w-0 max-w-full",
        classNamePrefix: "react-select",
        menuPortalTarget: document.body,
        menuPosition: "fixed",
        menuShouldScrollIntoView: false,
        styles: selectMenuStyles,
      };

      return (
        <div className="min-h-screen bg-gray-100 pb-6 sm:pb-8">
          <div className="mx-auto w-full max-w-7xl px-3 sm:px-4 lg:px-6 pt-4 sm:pt-6">
            <div className="overflow-x-hidden rounded-lg bg-white px-4 py-5 shadow-md sm:px-6 sm:py-6 lg:px-8">
              <header className="mb-6 border-b border-gray-100 pb-4 sm:mb-8">
                <div className="flex min-w-0 items-center gap-2 sm:gap-3">
                  <ArrowBack onClick={handleCancelClick} />
                  <h2 className="min-w-0 truncate text-lg font-bold text-gray-900 sm:text-xl">
                    {titulo}
                  </h2>
                </div>
              </header>

              <div className="grid grid-cols-1 gap-6 sm:gap-8 lg:grid-cols-12">
                {/* Datos generales */}
                <section className="min-w-0 space-y-4 lg:col-span-7">
                  <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-500">
                    {t("label_datos_generales") || "Datos generales"}
                  </h3>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div className="min-w-0 space-y-1.5 sm:col-span-1">
                      <label
                        htmlFor="estado_solicitud"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_estado_solicitud")}<span className="text-red-500">*</span>
                      </label>
                      <Select
                        {...reactSelectLayoutProps}
                        options={listaEstadosSolicitud}
                        value={estadoSolicitudSelected}
                        onChange={(option) => setEstadoSolicitudSelected(option)}
                        placeholder={t("placeholder_seleccione_estado_solicitud")}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={false}
                      />
                    </div>
                    <div className="min-w-0 space-y-1.5 sm:col-span-1">
                      <label
                        htmlFor="cantidad_vehiculos_requeridos"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_cantidad_vehiculos_requeridos")}<span className="text-red-500">*</span>
                      </label>
                      <input
                        id="cantidadVehiculosRequeridos"
                        name="cantidadVehiculosRequeridos"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={formData?.cantidadVehiculosRequeridos ?? ""}
                        onChange={handleInputChange}
                        autoComplete="off"
                        className={ESTILO_INPUT_GENERICO}
                        required
                        maxLength={charLimits.cantidadVehiculosRequeridos}
                        placeholder={t("placeholder_ingresa_cantidad_vehiculos_requeridos")}
                      />
                      <p className="flex justify-end text-xs text-gray-500 sm:text-sm">
                        {formData?.cantidadVehiculosRequeridos?.length ?? 0}/{charLimits.cantidadVehiculosRequeridos}
                      </p>
                    </div>
                  </div>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                    <div className="min-w-0 space-y-1.5">
                      <label
                        htmlFor="codigo"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_codigo")}
                      </label>
                      <input
                        id="codigo"
                        name="codigo"
                        type="text"
                        value={formData?.codigo ?? ""}
                        onChange={handleInputChange}
                        className={ESTILO_INPUT_GENERICO}
                        required
                        maxLength={charLimits.codigo}
                        placeholder={t("placeholder_ingresa_codigo")}
                      />
                      <p className="flex justify-end text-xs text-gray-500 sm:text-sm">
                        {formData?.codigo?.length ?? 0}/{charLimits.codigo}
                      </p>
                    </div>
                    <div className="min-w-0 space-y-1.5">
                      <label
                        htmlFor="nombre"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_descripcion")}<span className="text-red-500">*</span>
                      </label>
                      <input
                        id="descripcion"
                        name="descripcion"
                        type="text"
                        value={formData?.descripcion ?? ""}
                        onChange={handleInputChange}
                        className={ESTILO_INPUT_GENERICO}
                        required
                        maxLength={charLimits.descripcion}
                        placeholder={t("placeholder_ingresa_descripcion")}
                      />
                      <p className="flex justify-end text-xs text-gray-500 sm:text-sm">
                        {formData?.descripcion?.length ?? 0}/{charLimits.descripcion}
                      </p>
                    </div>
                    <div className="min-w-0 space-y-1.5 sm:col-span-2 xl:col-span-1">
                      <label
                        htmlFor="nota"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_nota")}
                      </label>
                      <textarea
                        id="nota"
                        name="nota"
                        type="text"
                        value={formData?.nota ?? ""}
                        onChange={handleInputChange}
                        className={ESTILO_INPUT_GENERICO}
                        required
                        maxLength={charLimits.nota}
                        placeholder={t("placeholder_ingresa_nota")}
                        rows={4}
                      />
                      <p className="flex justify-end text-xs text-gray-500 sm:text-sm">
                        {formData?.nota?.length ?? 0}/{charLimits.nota}
                      </p>
                    </div>
                  </div>
                </section>

                {/* Geocercas y ruta */}
                <section className="min-w-0 space-y-4 border-t border-gray-100 pt-6 sm:pt-8 lg:col-span-7">
                  <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-500">
                    {t("label_geocercas") || "Geocercas"}
                  </h3>
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
                    <div className="min-w-0 space-y-1.5">
                      <label
                        htmlFor="geocerca_inicio"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_geocerca_inicio")}<span className="text-red-500">*</span>
                      </label>
                      <Select
                        {...reactSelectLayoutProps}
                        options={listaGeocercas}
                        value={geocercaInicioSelected}
                        onChange={(option) => setGeocercaInicioSelected(option)}
                        placeholder={t("placeholder_seleccione_geocerca")}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={false}
                      />
                    </div>
                    <div className="min-w-0 space-y-1.5">
                      <label
                        htmlFor="geocerca_fin"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_geocerca_fin")}<span className="text-red-500">*</span>
                      </label>
                      <Select
                        {...reactSelectLayoutProps}
                        options={listaGeocercas}
                        value={geocercaFinSelected}
                        onChange={(option) => setGeocercaFinSelected(option)}
                        placeholder={t("placeholder_seleccione_geocerca")}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={false}
                      />
                    </div>
                    <div className="min-w-0 space-y-1.5 sm:col-span-2 xl:col-span-1">
                      <label
                        htmlFor="georuta"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_georuta")}<span className="text-red-500">*</span>
                      </label>
                      <Select
                        {...reactSelectLayoutProps}
                        options={listaGeoruta}
                        value={georutaSelected}
                        onChange={(option) => setGeorutaSelected(option)}
                        placeholder={t("placeholder_seleccione_georuta")}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={false}
                      />
                    </div>
                  </div>
                </section>

                {/* Mapa: tras geocercas en móvil; columna derecha fija en lg+ (iPad landscape / desktop) */}
                <aside className="min-w-0 space-y-3 border-t border-gray-100 pt-6 lg:col-span-5 lg:col-start-8 lg:row-start-1 lg:row-span-2 lg:self-start lg:border-t-0 lg:pt-0">
                  <div className="lg:sticky lg:top-4">
                    <label className="mb-2 block text-sm font-medium text-gray-700 sm:text-base">
                      {t("label_vista_previa")}
                    </label>
                    <GraficoViajeComponent
                      geocercaInicioSelected={geocercaInicioSelected}
                      geocercaFinSelected={geocercaFinSelected}
                      georutaSelected={georutaSelected}
                      minHeightClass="h-[min(45vh,400px)] min-h-[240px] sm:min-h-[320px] lg:min-h-[400px] lg:h-[min(70vh,640px)]"
                    />
                  </div>
                </aside>

                {/* Fechas y horarios — ancho completo debajo del mapa en desktop */}
                <section className="min-w-0 w-full space-y-4 border-t border-gray-100 pt-6 sm:pt-8 lg:col-span-12">
                  <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-500">
                    {t("label_fecha_hora_inicio")} / {t("label_fecha_hora_fin")}
                  </h3>
                  <div className="grid w-full grid-cols-1 gap-6 sm:grid-cols-2 sm:gap-4 lg:gap-6">
                    <div className="min-w-0 space-y-3">
                      <label
                        htmlFor="fecha_hora_inicio"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_fecha_hora_inicio")}<span className="text-red-500">*</span>
                      </label>
                      <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2">
                        <Calendar
                          value={formData?.fechaInicio ?? ""}
                          onChange={(date) => setFormData({ ...formData, fechaInicio: date })}
                          placeholder={t("placeholder_seleccione_fecha")}
                          id="fecha_inicio"
                          name="fecha_inicio"
                        />
                        <TimeComponent
                          value={formData?.horaInicio ?? ""}
                          onChange={(time) => setFormData({ ...formData, horaInicio: time })}
                          placeholder={t("placeholder_seleccione_hora")}
                          id="fecha_hora_inicio"
                          name="fecha_hora_inicio"
                        />
                      </div>
                    </div>
                    <div className="min-w-0 space-y-3">
                      <label
                        htmlFor="label_fecha_hora_fin"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_fecha_hora_fin")}<span className="text-red-500">*</span>
                      </label>
                      <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2">
                        <Calendar
                          value={formData?.fechaFin ?? ""}
                          onChange={(date) => setFormData({ ...formData, fechaFin: date })}
                          placeholder={t("placeholder_seleccione_fecha")}
                          id="fecha_fin"
                          name="fecha_fin"
                        />
                        <TimeComponent
                          value={formData?.horaFin ?? ""}
                          onChange={(time) => setFormData({ ...formData, horaFin: time })}
                          placeholder={t("placeholder_seleccione_hora")}
                          id="fecha_hora_fin"
                          name="fecha_hora_fin"
                        />
                      </div>
                    </div>
                  </div>
                </section>

                {/* Notificaciones — ancho completo */}
                <section className="min-w-0 w-full space-y-4 border-t border-gray-100 pt-6 sm:pt-8 lg:col-span-12">
                  <h3 className="text-sm font-semibold uppercase tracking-wide text-gray-500">
                    {t("label_notificaciones") || "Notificaciones"}
                  </h3>
                  <div className="flex w-full flex-col gap-4">
                    <div className="min-w-0 w-full space-y-1.5">
                      <label
                        htmlFor="notificar_inicio_viaje"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_notificar_inicio_viaje")}
                      </label>
                      <Select
                        {...reactSelectLayoutProps}
                        options={listaPersonas}
                        value={personaNotificarInicioViaje}
                        onChange={(option) => setPersonaNotificarInicioViaje(option)}
                        placeholder={t("placeholder_seleccione_persona")}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={true}
                      />
                    </div>
                    <div className="min-w-0 w-full space-y-1.5">
                      <label
                        htmlFor="notificar_fin_viaje"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_notificar_fin_viaje")}
                      </label>
                      <Select
                        {...reactSelectLayoutProps}
                        options={listaPersonas}
                        value={personaNotificarFinViaje}
                        onChange={(option) => setPersonaNotificarFinViaje(option)}
                        placeholder={t("placeholder_seleccione_persona")}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={true}
                      />
                    </div>
                    <div className="min-w-0 w-full space-y-1.5">
                      <label
                        htmlFor="notificar_alerta"
                        className="block text-sm font-medium text-gray-700 sm:text-base"
                      >
                        {t("label_notificar_alerta")}
                      </label>
                      <Select
                        {...reactSelectLayoutProps}
                        options={listaPersonas}
                        value={personaNotificarAlerta}
                        onChange={(option) => setPersonaNotificarAlerta(option)}
                        placeholder={t("placeholder_seleccione_persona")}
                        isClearable={true}
                        isSearchable={true}
                        isMulti={true}
                      />
                    </div>
                  </div>
                </section>

                {/* Acciones */}
                <footer className="border-t border-gray-100 pt-6 sm:pt-8 lg:col-span-12">
                  <div className="flex flex-col-reverse gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <button
                      type="button"
                      className={`${ESTILO_BOTON_GENERAL_CANCELAR} w-full sm:w-auto`}
                      onClick={handleCancelClick}
                    >
                      {t("label_cancelar")}
                    </button>
                    {requestSend === false && (
                      <button
                        type="button"
                        className={`${ESTILO_BOTON_GENERAL_ACEPTAR} w-full sm:w-auto`}
                        onClick={handleSaveClick}
                      >
                        {t("label_aceptar")}
                      </button>
                    )}
                    {requestSend === true && (
                      <button
                        type="button"
                        className={`${ESTILO_BOTON_GENERAL_ACEPTAR} w-full sm:w-auto`}
                        disabled
                      >
                        <div className="flex items-center justify-center gap-2">
                          <Spinner size="sm" color="white" />
                          <span>{t("label_aceptar")}</span>
                        </div>
                      </button>
                    )}
                  </div>
                </footer>
              </div>
            </div>
          </div>
          <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
          <ToastComponent
            visible={toastVisible}
            message={toastMessage}
            type={toastType}
            onClose={() => setToastVisible(false)}
          />
        </div>
      );
    } catch (err) {
      console.log('formData render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
